import React, { useEffect } from 'react'
import { useState } from "react";
import '../dashboard/dashboard.scss'
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/Sidebar';
import Header from "../navbar/Navbar";
import { fetchCategories } from '../../services/category';

function DashboardLayout() {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  
    return (
        <div>
            <div className={`dashboard ${isSidebarOpen ? "sidebar-open" : ""}`}>
                <Sidebar isOpen={isSidebarOpen} toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
                <div className="main-content">
                    <Header toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)} />
                    <div className="content-area">

                        <Outlet />
                        {/* <RecentList/> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DashboardLayout